import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BrokerNoteFormType } from '@/pages/mortgage-workflow/routes/BrokerNoteGenerator/schema/brokerNoteSchema';

const initialState: BrokerNoteFormType = {
  name1: '',
  citizenship1: '',
  residency1: '',
  occupation1: '',
  employment1: '',
  employer1: '',
  since1: '',
  currency1: '',
  fx1: '',
  salary1: '',
  deductions1: '',
  allowances1: '',
  commission1: '',
  bonusThis: '',
  bonusLast: '',
  number1: '',
  anyLiabilities: '',
  detailsOfDebt: '',
  date: '',
  name2: '',
  citizenship2: '',
  residency2: '',
  occupation2: '',
  employment2: '',
  employer2: '',
  since2: '',
  currency2: '',
  fx2: '',
  salary2: '',
  deductions2: '',
  allowances2: '',
  commission2: '',
  bonusThis2: '',
  bonusLast2: '',
  number2: '',
  pricing: '',
  interestRate: '',
  valuation: '',
  livingStatus: '',
  mortgage: '',
  rentalExpense: '',
  rentalExpenseAud: '',
  maritalStatus: '',
  kidsNumber: '',
  kidsAges: '',
  privateEducation: '',
  purpose: '',
  purposeEquity: '',
  lvr: '',
  security: '',
  aipRentalYield: '',
  aipRentM: '',
  ccTotalLimit: '',
  reduceLimit: '',
  ccNewLimit: '',
  lender: '',
  existingCustomer: '',
} as BrokerNoteFormType;

const brokerNoteFormSlice = createSlice({
  name: 'brokerNoteForm',
  initialState,
  reducers: {
    setForm: (state, action: PayloadAction<BrokerNoteFormType>) => {
      return action.payload;
    },
    updateField: (
      state,
      action: PayloadAction<{ name: keyof BrokerNoteFormType; value: any }>,
    ) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    resetForm: () => initialState,
  },
});

export const { setForm, updateField, resetForm } = brokerNoteFormSlice.actions;
export default brokerNoteFormSlice.reducer;
